import type { Theme } from './light'

/**
 * Template B – Warm & Freundlich
 * 
 * Wärmeres Design-Template mit gelb-/orangetönen
 * und freundlicherem Erscheinungsbild
 */
export const warmTheme: Theme = {
  name: 'warm',
  colors: {
    // Primärfarben basierend auf UI-Styleguide
    primary: '#e6b86b',
    primaryLight: '#e0d26f',
    primaryDark: '#d9a54e',
    
    // Sekundärfarben basierend auf UI-Styleguide
    secondary: '#cf7666',
    secondaryDark: '#b5574a',
    
    // Status-Farben basierend auf UI-Styleguide
    success: '#7b9d7c',
    danger: '#ea1f0e',
    warning: '#e2c56c',
    info: '#85c7c6',
    
    // Hintergrundfarben
    background: '#f1e2c1',
    backgroundLight: '#f8f4e6',
    backgroundSecondary: '#e9ecef',
    backgroundTertiary: '#e5d5b3', // Dunkler als Body (#f1e2c1) für besseren Kontrast
    backgroundDark: '#e5d5b3',
    surface: '#ffffff',
    
    // Textfarben
    text: '#1d1d1b',
    textLight: '#58757b',
    textDark: '#1d1d1b',
    textOnPrimary: '#1d1d1b',
    
    // UI-Elemente
    border: '#d6cab0',
    hover: '#f8f4e6',
    focus: 'rgba(230, 184, 107, 0.25)',
    
    // Schatten
    shadowColor: 'rgba(0, 0, 0, 0.08)',
  },
  
  // Schatten-Definitionen
  shadows: {
    sm: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.05)',
    md: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
    lg: '0 1rem 3rem rgba(0, 0, 0, 0.15)',
  },
  
  // Weitere Theme-spezifische Eigenschaften
  properties: {
    headerHeight: '60px',
    sidebarWidth: '250px',
    borderRadius: {
      sm: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem',
    },
    transitions: {
      fast: '150ms ease-in-out',
      normal: '300ms ease-in-out',
      slow: '500ms ease-in-out',
    },
    fonts: {
      family: '"Inter", "Roboto", "Helvetica Neue", sans-serif',
      sizes: {
        h1: '2rem', // 32px
        h2: '1.5rem', // 24px
        h3: '1.125rem', // 18px
        body: '1rem', // 16px
        small: '0.875rem', // 14px
      },
      weights: {
        regular: '400',
        medium: '500',
        semibold: '600',
        bold: '700'
      }
    },
    buttons: {
      primary: {
        background: '#e6b86b',
        text: '#1d1d1b',
        hover: '#e0d26f'
      },
      secondary: {
        background: '#cf7666',
        text: '#ffffff',
        hover: '#b5574a'
      },
      neutral: {
        background: '#d6cab0',
        text: '#1d1d1b',
        hover: '#c8b99a'
      },
      success: {
        background: '#7b9d7c',
        text: '#ffffff',
        hover: '#5e7e5f'
      },
      warning: {
        background: '#e2c56c',
        text: '#1d1d1b',
        hover: '#d6b950'
      },
      danger: {
        background: '#ea1f0e',
        text: '#ffffff',
        hover: '#cf7666'
      }
    },
    alerts: {
      info: {
        background: '#c2f1eb',
        text: '#1d1d1b',
        icon: '#018ea9'
      },
      success: {
        background: '#acd7c8',
        text: '#1d1d1b',
        icon: '#7b9d7c'
      },
      warning: {
        background: '#f1e2c1',
        text: '#1d1d1b',
        icon: '#e0d26f'
      },
      danger: {
        background: '#f6c6b8',
        text: '#1d1d1b',
        icon: '#ea1f0e'
      }
    }
  },
}
